@import './assets/fonts/fonts.css';

:root {
  --text: #ffffff;
  --text-h: #ffffff;
  --bg: #000000;
  --border: #333333;
  --code-bg: #1a1a1a;
  --accent: #430397;
  --accent-secondary: #fe2f61;
  --accent-bg: rgba(67, 3, 151, 0.1);
  --accent-border: rgba(67, 3, 151, 0.5);
  --social-bg: rgba(30, 30, 30, 0.5);
  --shadow:
    rgba(0, 0, 0, 0.5) 0 10px 15px -3px, rgba(0, 0, 0, 0.3) 0 4px 6px -2px;

  --sans: 'Rock Sans', system-ui, 'Segoe UI', Roboto, sans-serif;
  --heading: 'Rock Serif', 'Rock Sans', system-ui, 'Segoe UI', Roboto, sans-serif;
  --mono: ui-monospace, Consolas, monospace;

  font: 16px/1.6 var(--sans);
  letter-spacing: 0.01em;
  color-scheme: dark;
  color: var(--text);
  background: var(--bg);
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  @media (max-width: 1024px) {
    font-size: 15px;
  }
}

#root {
  max-width: 100%;
  margin: 0 auto;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

body {
  margin: 0;
  background-color: #000;
}

h1,
h2 {
  font-family: var(--heading);
  font-weight: 700;
  color: var(--text-h);
  letter-spacing: -0.02em;
}

h1 {
  font-size: 48px;
  margin: 32px 0;
  @media (max-width: 1024px) {
    font-size: 32px;
    margin: 20px 0;
  }
}
h2 {
  font-size: 32px;
  line-height: 1.3;
  margin: 0 0 16px;
  @media (max-width: 1024px) {
    font-size: 24px;
  }
}
p {
  margin: 0;
}

code,
.counter {
  font-family: var(--mono);
  display: inline-flex;
  border-radius: 4px;
  color: var(--text-h);
}

code {
  font-size: 15px;
  line-height: 135%;
  padding: 4px 8px;
  background: var(--code-bg);
}
